import React from "react";
import { Loader2 } from "lucide-react";

export default function Loading({ full = false, label = "Loading..." }) {
  return (
    <div
      className={
        full
          ? "min-h-screen w-full flex flex-col items-center justify-center gap-3 bg-[color:var(--pa-background)]"
          : "w-full flex flex-col items-center justify-center gap-3 py-16"
      }
      data-testid="loading-indicator"
    >
      <Loader2 className="animate-spin" size={28} color="var(--pa-gold)" />
      <p className="text-sm" style={{ color: "var(--pa-text-secondary)" }}>{label}</p>
    </div>
  );
}
